export default "__VITE_ASSET__Bwm85nW7__"